import React, { useState, useEffect } from "react";
import { HiMenu, HiChevronDown } from "react-icons/hi";
import { RxCross2 } from "react-icons/rx";
import { Link } from "react-router-dom";
import logo from "../../../../../images/msgnotifier.svg";
import {
  IoMegaphoneOutline,
  IoPeopleOutline,
  IoChatbubbleEllipsesOutline,
  IoBarChartOutline,
} from "react-icons/io5";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";

export default function Navbar() {
  const [openMenu, setOpenMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showFeatures, setShowFeatures] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const features = [
    {
      title: "WhatsApp Campaign",
      desc: "Send bulk messages",
      icon: <IoMegaphoneOutline size={24} />,
      path: "/whatsApp_campaign",
    },
    {
      title: "Audience Targeting",
      desc: "Automate responses",
      icon: <IoPeopleOutline size={24} />,
      path: "/audience_targeting",
    },
    {
      title: "Personalized Messages",
      desc: "Developers integration",
      icon: <HiOutlineAdjustmentsHorizontal size={24} />,
      path: "/personalized_messages",
    },
    {
      title: "Automated Replies & Chat Bot",
      desc: "Track performance",
      icon: <IoChatbubbleEllipsesOutline size={24} />,
      path: "/automated_replies",
    },
  ];

  return (
    <>
      <nav
        className={`navbar navbar-expand-md border transition-all ${isScrolled ? "bg-white shadow-sm" : "bg-transparent"}`}
      >
        <div className="container py-2 font-inter ">
          <Link
            className="navbar-brand"
            to="/"
            onClick={() => window.scrollTo(0, 0)}
          >
            <img
              src={logo}
              alt="Logo"
              className="img-fluid"
              style={{ height: "30px", width: "100px", objectFit: "cover" }}
            />
          </Link>

          <div className="collapse navbar-collapse d-none d-md-flex justify-content-between">
            <ul className="navbar-nav mx-auto gap-lg-4">
              <li className="nav-item">
                <Link className="nav-link text-dark fw-semibold" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-dark fw-semibold" to="/about">
                  About
                </Link>
              </li>

              <li
                className="nav-item position-relative"
                onMouseEnter={() => setShowFeatures(true)}
                onMouseLeave={() => setShowFeatures(false)}
              >
                <div className="nav-link text-dark fw-semibold cursor-pointer d-flex align-items-center gap-1">
                  Features{" "}
                  <HiChevronDown
                    className={`transition-all ${showFeatures ? "rotate-180" : ""}`}
                  />
                </div>

                {showFeatures && (
                  <div className="dropdown-custom shadow-sm font-inter border rounded-4 bg-white p-2 mx-5">
                    <div className="row g-2" style={{ width: "280px" }}>
                      {features.map((f, i) => (
                        <div className="col-12" key={i}>
                          <Link
                            to={f.path}
                            className="feature-item p-2 d-block text-decoration-none rounded-3"
                          >
                            <div className="d-flex align-items-center gap-2">
                              <span className="fs-4">{f.icon}</span>
                              <div>
                                <div className="fw-bold text-dark small">
                                  {f.title}
                                </div>
                                <div
                                  className="text-muted"
                                  style={{ fontSize: "10px" }}
                                >
                                  {f.desc}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </li>

              <li className="nav-item">
                <Link className="nav-link text-dark fw-semibold" to="/pricing">
                  Pricing
                </Link>
              </li>
            </ul>
            <Link to="/login">
              <button className="btn rounded-pill bg-neon-purple text-white px-4 py-2 fw-semibold hover-scale">
                Login
              </button>
            </Link>
          </div>

          <button
            className="btn d-md-none p-2"
            onClick={() => setOpenMenu(true)}
          >
            <HiMenu size={32} className="text-dark" />
          </button>
        </div>
      </nav>

      {openMenu && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
          style={{ zIndex: 1040 }}
          onClick={() => setOpenMenu(false)}
        />
      )}

      <div
        className={`mobile-sidebar position-fixed top-0 end-0 h-100 bg-white shadow-lg p-4 ${openMenu ? "open" : ""}`}
        style={{ zIndex: 1050 }}
      >
        <div className="d-flex justify-content-between align-items-center mb-5">
          <img src={logo} alt="Logo" style={{ maxWidth: "120px" }} />
          <RxCross2 size={28} onClick={() => setOpenMenu(false)} />
        </div>

        <ul className="list-unstyled d-flex flex-column gap-3">
          <li>
            <Link
              className="mobile-link"
              to="/"
              onClick={() => setOpenMenu(false)}
            >
              Home
            </Link>
          </li>

          <li>
            <div
              className="mobile-link d-flex justify-content-between align-items-center"
              onClick={() => setShowFeatures(!showFeatures)}
            >
              Features{" "}
              <HiChevronDown className={showFeatures ? "rotate-180" : ""} />
            </div>
            {showFeatures && (
              <div className="ps-3 mt-2 border-start">
                {features.map((f, i) => (
                  <Link
                    key={i}
                    className="d-block py-2 text-muted text-decoration-none"
                    to={f.path}
                    onClick={() => setOpenMenu(false)}
                  >
                    {f.title}
                  </Link>
                ))}
              </div>
            )}
          </li>

          <li>
            <Link
              className="mobile-link"
              to="/about"
              onClick={() => setOpenMenu(false)}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              className="mobile-link"
              to="/pricing"
              onClick={() => setOpenMenu(false)}
            >
              Pricing
            </Link>
          </li>
        </ul>
        <div className="mt-5 border-top pt-4">
          <Link to="/login">
            <button className="btn w-100 rounded-pill bg-neon-purple text-white py-3 fw-medium">
              Login
            </button>
          </Link>
        </div>
      </div>
    </>
  );
}
